import { css } from 'styled-components';

const cssOverride = props =>
  props.css &&
  css`
    ${props.css}
  `;

export default cssOverride;
